import { Form, Input, Button, Typography, theme, Image } from "antd";
import { useAuth } from "../../AuthContext";
import { POSTLogin } from "../../helpers/autenticacion/POSTLogin";
import { useState } from "react";
import { ExclamationCircleOutlined, LoginOutlined } from "@ant-design/icons";
import "./index.css";

const { Text } = Typography;
const version = process.env.REACT_APP_VERSION;

const Login = () => {
  const [form] = Form.useForm();
  const { token } = theme.useToken();
  const { login } = useAuth();
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);

  const handleInputChange = () => {
    if (loginError) setLoginError("");
  };

  const onFinish = async (values) => {
    setLoginLoading(true);
    setLoginError("");

    try {
      const { username, password } = values;
      const responseLogin = await POSTLogin({
        nombreUsuario: username,
        contrasenia: password,
      });

      if (responseLogin.status === 200) {
        login(responseLogin.data);
      } else {
        setLoginError(
          responseLogin?.data?.message || "Error al iniciar sesión",
        );
      }
    } catch {
      setLoginError("Error de conexión");
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <div id="mobile-root">
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          background: token.colorBgContainer,
          position: "relative",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "24px 16px",
          }}
        >
          <Form
            className="fade-in-up"
            form={form}
            name="login"
            onFinish={onFinish}
            onValuesChange={handleInputChange}
            style={{
              width: "100%",
              maxWidth: "400px",
              background: token.colorBgElevated,
              padding: "32px",
              borderRadius: token.borderRadiusLG,
            }}
          >
            {/* Logo */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                marginBottom: "20px",
              }}
            >
              <Image
                src="/Logo_color.svg"
                alt="Logo"
                width={210}
                preview={false}
              />
            </div>

            {/* Bienvenidos */}
            <Text
              style={{
                display: "block",
                textAlign: "center",
                fontSize: 21,
                fontWeight: 700,
                marginBottom: 12,
              }}
            >
              Bienvenido
            </Text>

            {/* Brand divider */}
            <div
              style={{
                width: 50,
                height: 3,
                background: "#fb9a1a",
                borderRadius: 3,
                margin: "0 auto 24px",
              }}
            />

            <Form.Item
              name="username"
              rules={[{ required: true, message: "Ingrese su usuario" }]}
            >
              <Input
                placeholder="Usuario"
                size="large"
                style={{
                  background: token.colorFillAlter,
                  color: token.colorText,
                  borderColor: token.colorBorder,
                  borderRadius: token.borderRadius,
                  transition: "all 0.3s",
                }}
                onFocus={(e) =>
                  (e.target.style.borderColor = token.colorPrimary)
                }
                onBlur={(e) => (e.target.style.borderColor = token.colorBorder)}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: "Ingrese su contraseña" }]}
            >
              <Input.Password
                placeholder="Contraseña"
                size="large"
                style={{
                  background: token.colorFillAlter,
                  color: token.colorText,
                  borderColor: token.colorBorder,
                  borderRadius: token.borderRadius,
                  transition: "all 0.3s",
                }}
                styles={{
                  input: {
                    background: token.colorFillAlter,
                  },
                }}
                onFocus={(e) =>
                  (e.target.style.borderColor = token.colorPrimary)
                }
                onBlur={(e) => (e.target.style.borderColor = token.colorBorder)}
              />
            </Form.Item>

            {loginError && (
              <div
                style={{
                  marginBottom: 16,
                  padding: "10px 14px",
                  background: "#fef2f2",
                  borderLeft: "3px solid #ef4444",
                  borderRadius: 8,
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#dc2626",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <ExclamationCircleOutlined /> {loginError}
                </Text>
              </div>
            )}

            <Form.Item>
              <Button
                loading={loginLoading}
                type="primary"
                htmlType="submit"
                icon={<LoginOutlined />}
                style={{
                  width: "100%",
                  height: "50px",
                  fontSize: "17px",
                  fontWeight: 500,
                  borderRadius: token.borderRadiusLG,
                  background: "#fb9a1a",
                  borderColor: "#fb9a1a",
                }}
              >
                Ingresar
              </Button>
            </Form.Item>
          </Form>
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "14px 24px",
            borderTop: "1px solid rgba(0,0,0,0.06)",
          }}
        >
          <Text type="secondary" style={{ fontSize: 13 }}>
            © {new Date().getFullYear()} Innercor S.R.L
          </Text>
          <Text type="secondary" style={{ fontSize: 13, fontWeight: 500 }}>
            {version}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default Login;
